function HeaderSection({ namaSurah, toggleLeftSection }) {
  return (
    <div className="bg-slate-50 h-[95px] w-full flex  justify-between items-center px-8 border-b border-gray-500">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          <h3 className="text-xl font-bold text-hijau">{namaSurah}</h3>
        </div>
        {/* <img src="/volume.png" alt="volume.png" height={30} width={30} /> */}
        <img
          src="/chevron.png"
          alt="chevron.png"
          height={20}
          width={20}
          onClick={toggleLeftSection}
          className="cursor-pointer block lg:hidden"
        />
      </div>
    </div>
  );
}

export default HeaderSection;
